import { transformSearch } from "@/api/helper.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import caseActivityPaymentService from "../services/case-activity-payment-service";

export const caseActivityPaymentSearchQuery = z.object({
	search: z.string().optional(),
	status: z.string().optional(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
});

export const caseActivityPaymentQueryOptions = (
	search?: z.infer<typeof caseActivityPaymentSearchQuery>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["case_activity_payments", search],
		queryFn: () =>
			caseActivityPaymentService.getActivityPayments(
				transformSearch(search, ["status", "search"]),
			),
		...options,
	});
};
